import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { CrossXssScriptService } from './cross-xss-script-service';
import { DeviceDetectorService } from 'ngx-device-detector';

const METHODS_TO_VALIDATE = ['POST', 'PUT', 'PATCH'];
export interface DeviceInfoModel {
  browser: string;
  browserVersion: string;
  device: string;
  deviceType: string;
  os: string;
  osVersion: string;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  isDesktopMode: boolean;
}
export const xssInterceptor: HttpInterceptorFn = (req, next) => {
  if (!METHODS_TO_VALIDATE.includes(req.method)) {
    req = deviceInfoInterceptor(req);
    return next(req);
  }
  const xssService = inject(CrossXssScriptService);
  if (req.body) {
    const xssFields = findXssFields(req.body, xssService);
    if (xssFields.length) {
      return throwError(
        () =>
          new HttpErrorResponse({
            status: 400,
            statusText: 'XSS content detected',
            error: {
              message: 'Unsafe HTML detected',
              fields: xssFields
            }
          })
      );
    }
  }
  req = deviceInfoInterceptor(req);
  return next(req);
};

// function containsXss(obj: unknown, xssService: XssService): boolean {
//   if (typeof obj === 'string') {
//     return xssService.hasXss(obj);
//   }

//   if (Array.isArray(obj)) {
//     return obj.some(item => containsXss(item, xssService));
//   }

//   if (obj !== null && typeof obj === 'object') {
//     return Object.values(obj).some(value => containsXss(value, xssService));
//   }

//   return false;
// }
function deviceInfoInterceptor(req: any) {
  const deviceService = inject(DeviceDetectorService);
  const info = deviceService.getDeviceInfo();
  const deviceInfo: DeviceInfoModel = {
    browser: info.browser,
    browserVersion: info.browser_version,
    device: info.device,
    deviceType: info.deviceType,
    os: info.os,
    osVersion: info.os_version,
    isMobile: deviceService.isMobile(),
    isTablet: deviceService.isTablet(),
    isDesktop: deviceService.isDesktop(),
    isDesktopMode: deviceService.isDesktopModeEnabled()
  };
  return req.clone({
    setHeaders: {
      'X-Device-Info': toBase64Url(deviceInfo)
    }
  });
}
function toBase64Url(value: unknown): string {
  const base64 = btoa(
    encodeURIComponent(JSON.stringify(value)).replace(/%([0-9A-F]{2})/g, (_, p1) =>
      String.fromCharCode(parseInt(p1, 16))
    )
  );
  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
function findXssFields(obj: unknown, xssService: CrossXssScriptService, path = ''): string[] {
  const fields: string[] = [];
  if (typeof obj === 'string') {
    if (xssService.hasXss(obj)) {
      fields.push(path);
    }
    return fields;
  }

  if (Array.isArray(obj)) {
    obj.forEach((item, index) => {
      fields.push(...findXssFields(item, xssService, `${path}[${index}]`));
    });
    return fields;
  }

  if (obj && typeof obj === 'object') {
    Object.entries(obj).forEach(([key, value]) => {
      const currentPath = path ? `${path}.${key}` : key;
      fields.push(...findXssFields(value, xssService, currentPath));
    });
  }

  return fields;
}
